module.exports = __webpack_public_path__ + "static/media/Exploding Bomb.1fd0826b.png";